
/**
Finds a header tag from an xml document.
* @param xmlDoc The xml document to look through.
* @returns The first header found or null.
*/
export function findHeader(xmlDoc: XMLDocument): Node {
  return xmlDoc.querySelector('h1, h2, h3, h4, h5, h6');
}

/**
Finds the first node that has text as children nodes.
* @param xmlDoc The xml document to look through.
* @returns First node with text children found or null.
*/
export function findTextNodeParent(xmlDoc: XMLDocument): Node {
  const treeWalker = xmlDoc.createTreeWalker(
    xmlDoc,
    NodeFilter.SHOW_ELEMENT,
    {
      acceptNode: node => {
        // Check if this element or any of its immediate text children has non-whitespace text
        for (let child of node.childNodes) {
          if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
            return NodeFilter.FILTER_ACCEPT;
          }
        }
        return NodeFilter.FILTER_SKIP;
      }
    }
  );

  return treeWalker.nextNode();
}
